export default {
  SEOParams: null,
  instance: null,
  report: null,
  emailTemplate: null,
  websocketUrl: null,
  isLoading: false,
  errors: null,
};
